module.exports = __webpack_public_path__ + "img/up.02d3af95.svg";